import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectPrepareDisclosuresWizard = createSelector(
  selectLoanApplication,
  ({ prepareDisclosuresWizard }) => prepareDisclosuresWizard ?? {},
);

export const selectIsPrepareDisclosuresWizardOpen = createSelector(
  selectPrepareDisclosuresWizard,
  ({ isOpen }) => !!isOpen,
);
